export class RequestRegisterCode {
  constructor(authApiClient) {
    this.authApiClient = authApiClient;
  }

  execute(payload) {
    return this.authApiClient.requestRegisterCode(payload);
  }
}
